import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import loginImg from "../../../assets/images/login.jpg";
import { fetchlogo } from "../../../ApiService/logo/logo";
import { loginUser } from "../../../ApiService/loginapi/loginapi"; // 👈 login API
import Switcher from "../../../components/switcher";
import BackToHome from "../../../components/back-to-home";

export default function Login() {
  const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;
  const [logos, setlogos] = useState([]);

  const location = useLocation();
  const redirectPath = location.state?.from || "/";
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });
  const navigate = useNavigate();

  // ✅ Fetch logo
  useEffect(() => {
    const getlogo = async () => {
      try {
        const Logos = await fetchlogo();
        setlogos(Logos[0]);
      } catch (err) {
        console.error("Failed to load logo:", err);
      }
    };
    getlogo();
  }, []);

  // ✅ Handle Input Change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ✅ Handle Login Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await loginUser(formData.email, formData.password);

      // Save user tokens in localStorage
      localStorage.setItem("access_token", response.access);
      localStorage.setItem("refresh_token", response.refresh);
      localStorage.setItem("customer_id", response.profile_data.customer_id);
      localStorage.setItem(
        "customer_first_name",
        response.profile_data.first_name
      );
      localStorage.setItem(
        "customer_last_name",
        response.profile_data.last_name
      );
      localStorage.setItem("customer_email", response.profile_data.email);

      console.log("Login Success:", response);
      toast.success("lonin successfully!", {
        position: "top-center",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });

      // Redirect to home or dashboard
      // navigate("/");
      navigate(redirectPath);
    } catch (error) {
      console.error("Login Failed:", error.message);
      toast.error("Longin failed", {
        position: "top-center",
        style: { borderRadius: "10px", background: "#333", color: "#fff" },
        icon: "❌",
      });
    }
  };

  return (
    <>
      <section className="md:h-screen py-36 flex items-center bg-orange-500/10 dark:bg-orange-500/20 bg-[url('../../assets/images/hero/bg-shape.png')] bg-center bg-no-repeat bg-cover">
        <div className="container relative">
          <div className="grid grid-cols-1">
            <div className="relative overflow-hidden rounded-md shadow dark:shadow-gray-700 bg-white dark:bg-slate-900">
              <div className="grid md:grid-cols-2 grid-cols-1 items-center">
                <div className="relative md:shrink-0">
                  <img
                    className="lg:h-full h-full w-full object-cover md:h-[34rem]"
                    src={loginImg}
                    alt=""
                  />
                </div>

                <div className="p-8 lg:px-20">
                  <div className="text-center">
                    <Link to="/" className="text-[22px] focus:outline-none">
  {logos?.header_logo ? (
    <img
      className="mx-auto block dark:hidden"
      src={`${BASE_MEDIA_URL}${logos.header_logo}`}
      alt="Header Logo"
      onError={(e) => {
        e.target.style.display = "none"; // hide broken image
        e.target.parentNode.innerHTML = "Spotyfi";
      }}
    />
  ) : (
    <span>Spotyfi</span>
  )}
</Link>

                  </div>

                  {/* ✅ Login Form */}
                  <form
                    className="text-start lg:py-20 py-8"
                    onSubmit={handleSubmit}
                  >
                    <div className="grid grid-cols-1">
                      <div className="mb-4">
                        <label className="font-semibold" htmlFor="LoginEmail">
                          Email Address:
                        </label>
                        <input
                          id="LoginEmail"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="name@example.com"
                        />
                      </div>

                      <div className="mb-4">
                        <label
                          className="font-semibold"
                          htmlFor="LoginPassword"
                        >
                          Password:
                        </label>
                        <input
                          id="LoginPassword"
                          name="password"
                          type="password"
                          value={formData.password}
                          onChange={handleChange}
                          className="mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0"
                          placeholder="Password"
                        />
                      </div>

                      <div className="flex justify-between mb-4">
                        <div className="flex items-center mb-0">
                          <input
                            name="rememberMe"
                            checked={formData.rememberMe}
                            onChange={handleChange}
                            className="form-checkbox rounded border-gray-100 dark:border-gray-800 text-green-500 me-2"
                            type="checkbox"
                            id="RememberMe"
                          />
                          <label
                            className="form-checkbox-label text-slate-400"
                            htmlFor="RememberMe"
                          >
                            Remember me
                          </label>
                        </div>
                        <p className="text-slate-400 mb-0">
                          <Link
                            to="/forgot-password"
                            className="text-slate-400"
                          >
                            Forgot password?
                          </Link>
                        </p>
                      </div>

                      <div className="mb-4">
                        <button
                          type="submit"
                          className="py-2 px-5 inline-block bg-green-500 text-white rounded-md w-full"
                        >
                          Login / Sign in
                        </button>
                      </div>

                      <div className="text-center">
                        <span className="text-slate-400 me-2">
                          Don't have an account?
                        </span>
                        <Link
                          to="/signup"
                          className="text-black dark:text-white font-bold inline-block"
                        >
                          Sign Up
                        </Link>
                      </div>
                    </div>
                  </form>

                  <div className="text-center">
                    <p className="mb-0 text-slate-400">
                      © {new Date().getFullYear()} Sportyfi. Design & Develop
                      with <i className="mdi mdi-heart text-red-600"></i> by{" "}
                      <Link
                        to="https://shreethemes.in/"
                        target="_blank"
                        className="text-reset"
                      >
                        Shreethemes
                      </Link>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Switcher />
      <BackToHome />
    </>
  );
}
